import React from 'react';

import type { IconProps } from '@squire/ui';
import { Icon } from '@squire/ui';

export const ChevronUpIcon: React.FC<IconProps> = ({
  size = 16,
  color = 'iconPrimary',
  ...props
}) => {
  return <Icon name="chevronUp" color={color} size={size} {...props} />;
};
